/* cSpell:disable */
import React from 'react';
import { InspectionLabelScore } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/common/InspectionLabelScore';
import { TextWithLineBreaks } from '../../../components/elements';
import { NullableFormattedNumber } from '../../../components/utils/NullableFormattedNumber';
import { useTranslate } from '../../../mixins/translate/translate';
import costIconImage from './assets/costIcon.png';
import deHinderVoorHetWegVaarverkeerIconImage from './assets/deHinderVoorHetWegVaarverkeerIcon.png';
import deHinderVoorHetWegverkeerIconImage from './assets/deHinderVoorHetWegverkeerIcon.png';
import droneIconImage from './assets/droneIcon.png';
import milieuIconImage from './assets/milieuIcon.png';
import regularInspectionIconImage from './assets/regularInspectionIcon.png';
import rendementIconImage from './assets/rendementIcon.png';
import rovIconImage from './assets/rovIcon.png';
import rwsLogo from './assets/rwsLogo.png';
import scubaInspectionIconImage from './assets/scubaInspectionIcon.png';
import veiligheidsrisicoscoreVanDeVaarWeggebruikerIconImage from './assets/veiligheidsrisicoscoreVanDeVaarWeggebruikerIcon.png';
import veiligheidsrisicoscoreVanDeWeggebruikerIconImage from './assets/veiligheidsrisicoscoreVanDeWeggebruikerIcon.png';
import veiligheidsrisicoscoreVanHetLuchtvaartverkeerIconImage from './assets/veiligheidsrisicoscoreVanHetLuchtvaartverkeerIcon.png';
import veiligheidsrisicoscoreVanHetObjectIconImage from './assets/veiligheidsrisicoscoreVanHetObjectIcon.png';
import veiligheidsrisicoscoreVoorDeInspecteurIconImage from './assets/veiligheidsrisicoscoreVoorDeInspecteurIcon.png';
import { getOverallScoreImage, getSubScoreImage } from './scoreImage';

type OptionalRovLabelScore = InspectionLabelScore | null | undefined;

export function GenericInspectionLabel(props: {
    deHinderVoorHetWegverkeerCategorie?: string | null | undefined;
    deHinderVoorHetWegverkeerKlasse?: string | null | undefined;
    deHinderVoorHetWegverkeerLabelScore?: OptionalRovLabelScore | undefined;
    inspectionType: 'rov' | 'scuba' | 'drone' | 'regular';
    kosten?: number | null | undefined;
    kostenLabelScore?: OptionalRovLabelScore | undefined;
    locatie?: string | undefined;
    milieuLabelScore?: OptionalRovLabelScore | undefined;
    naam?: string | undefined;
    omschrijving?: string | undefined;
    overallLabelScore?: OptionalRovLabelScore | undefined;
    rendementLabelScore?: OptionalRovLabelScore | undefined;
    veiligheidsrisicoscoreVanDeVaarWeggebruikerLabelScore?: OptionalRovLabelScore | undefined;
    veiligheidsrisicoscoreVanDeVaarWeggebruikerScore?: number | null | undefined;
    veiligheidsrisicoscoreVanHetLuchtvaartverkeerLabelScore?: OptionalRovLabelScore | undefined;
    veiligheidsrisicoscoreVanHetLuchtvaartverkeerScore?: number | null | undefined;
    veiligheidsrisicoscoreVanHetObjectLabelScore?: OptionalRovLabelScore | undefined;
    veiligheidsrisicoscoreVanHetObjectScore?: number | null | undefined;
    veiligheidsrisicoscoreVoorDeInspecteurLabelScore?: OptionalRovLabelScore | undefined;
    veiligheidsrisicoscoreVoorDeInspecteurScore?: number | null | undefined;
}) {
    const translate = useTranslate();

    return (
        <div
            style={{
                backgroundColor: 'white',
                border: '2px solid #000',
                borderRadius: '15px',
                width: '400px',
                fontFamily: 'Bitter',
                fontSize: '14px',
                color: 'black',
            }}
        >
            <div style={{ paddingLeft: '25px', paddingBottom: '25px', paddingRight: '10px' }}>
                <div className="row">
                    <div className="col-md-12" style={{ textAlign: 'center' }}>
                        <img width="44px" src={String(rwsLogo)} />
                    </div>
                </div>
                <div className="fw600 fs19 mt5">
                    {' '}
                    <span style={{ color: '#009FE3' }}>{translate('inspectionLabel.inspectionLoad')}</span>&nbsp;
                    {props.inspectionType === 'regular' && translate('inspectionLabel.traditionalInspection')}
                    {props.inspectionType === 'drone' && translate('inspectionLabel.droneInspection')}
                    {props.inspectionType === 'rov' && translate('inspectionLabel.rovInspection')}
                    {props.inspectionType === 'scuba' && translate('inspectionLabel.scubaInspection')}
                </div>
                <div>
                    <b>{props.naam}</b>, {props.locatie}{' '}
                </div>
                <div className="mt10">
                    <TextWithLineBreaks text={props.omschrijving} />
                </div>
                <div className="row mt10">
                    {' '}
                    <div className="col-md-4">{getOverallScoreImage(props.overallLabelScore)}</div>
                    <div className="col-md-4">
                        {props.inspectionType === 'regular' && <img width="100px" className="ml10 mt20" src={String(regularInspectionIconImage)} />}
                        {props.inspectionType === 'drone' && <img width="100px" className="ml10 mt20" src={String(droneIconImage)} />}
                        {props.inspectionType === 'rov' && <img width="100px" className="ml10 mt20" src={String(rovIconImage)} />}
                        {props.inspectionType === 'scuba' && <img width="100px" className="ml10 mt20" src={String(scubaInspectionIconImage)} />}
                    </div>
                </div>
                <div style={{ paddingTop: '15px' }}>
                    <b>{translate('inspectionLabel.cost')}</b>
                </div>
                <div className="row">
                    {' '}
                    <div className="col-md-4">
                        <img width="50px" src={String(costIconImage)} />
                    </div>
                    <div className="col-md-8">
                        {getSubScoreImage(props.kostenLabelScore)}
                        <br />
                        {translate('inspectionLabel.cost')}:{' '}
                        {props.kosten && (
                            <b>
                                &euro; <NullableFormattedNumber value={props.kosten} />
                            </b>
                        )}
                    </div>
                </div>
                <div style={{ paddingTop: '15px' }}>
                    <b>{translate('inspectionLabel.risk')}</b>
                </div>
                <div className="row">
                    {' '}
                    <div className="col-md-4">
                        <img width="50px" src={String(veiligheidsrisicoscoreVoorDeInspecteurIconImage)} />
                    </div>
                    <div className="col-md-8">
                        {getSubScoreImage(props.veiligheidsrisicoscoreVoorDeInspecteurLabelScore)}
                        {translate('inspectionLabel.inspectorRisk')}:{' '}
                        {props.veiligheidsrisicoscoreVoorDeInspecteurScore && (
                            <b>
                                <NullableFormattedNumber value={props.veiligheidsrisicoscoreVoorDeInspecteurScore} />
                            </b>
                        )}
                    </div>
                </div>

                <div className="row">
                    {' '}
                    <div className="col-md-4">
                        {((props.inspectionType === 'rov' || props.inspectionType === 'scuba') && (
                            <img width="100px" src={String(veiligheidsrisicoscoreVanDeVaarWeggebruikerIconImage)} />
                        )) || <img width="50px" src={String(veiligheidsrisicoscoreVanDeWeggebruikerIconImage)} />}
                    </div>
                    <div className="col-md-8">
                        {getSubScoreImage(props.veiligheidsrisicoscoreVanDeVaarWeggebruikerLabelScore)}
                        {translate('inspectionLabel.surroundingsRisc')}:{' '}
                        {props.veiligheidsrisicoscoreVanDeVaarWeggebruikerScore && (
                            <b>
                                <NullableFormattedNumber value={props.veiligheidsrisicoscoreVanDeVaarWeggebruikerScore} />
                            </b>
                        )}
                    </div>
                </div>
                {(props.inspectionType === 'drone' || props.inspectionType === 'regular') && (
                    <div className="row">
                        {' '}
                        <div className="col-md-4">
                            <img width="50px" src={String(veiligheidsrisicoscoreVanHetLuchtvaartverkeerIconImage)} />
                        </div>
                        <div className="col-md-8">
                            {getSubScoreImage(props.veiligheidsrisicoscoreVanHetLuchtvaartverkeerLabelScore)}
                            {translate('inspectionLabel.aviationRisc')}:{' '}
                            {props.veiligheidsrisicoscoreVanHetLuchtvaartverkeerScore && (
                                <b>
                                    <NullableFormattedNumber value={props.veiligheidsrisicoscoreVanHetLuchtvaartverkeerScore} />
                                </b>
                            )}
                        </div>
                    </div>
                )}
                <div className="row">
                    {' '}
                    <div className="col-md-4">
                        <img width="50px" src={String(veiligheidsrisicoscoreVanHetObjectIconImage)} />
                    </div>
                    <div className="col-md-8">
                        {getSubScoreImage(props.veiligheidsrisicoscoreVanHetObjectLabelScore)}
                        {translate('inspectionLabel.objectRisc')}:{' '}
                        {props.veiligheidsrisicoscoreVanHetObjectScore && (
                            <b>
                                <NullableFormattedNumber value={props.veiligheidsrisicoscoreVanHetObjectScore} />
                            </b>
                        )}
                    </div>
                </div>
                <div className="mt15">
                    <b>{translate('inspectionLabel.traffic')}</b>
                </div>
                <div className="row">
                    {' '}
                    <div className="col-md-4">
                        {((props.inspectionType === 'rov' || props.inspectionType === 'scuba') && (
                            <img width="100px" src={String(deHinderVoorHetWegVaarverkeerIconImage)} />
                        )) || <img width="50px" src={String(deHinderVoorHetWegverkeerIconImage)} />}
                    </div>
                    <div className="col-md-8">
                        {getSubScoreImage(props.deHinderVoorHetWegverkeerLabelScore)}
                        {translate('inspectionLabel.nuisance')}:{' '}
                        {props.deHinderVoorHetWegverkeerKlasse && <b>{props.deHinderVoorHetWegverkeerKlasse}</b>},&nbsp;
                        {translate('common.category')}:{' '}
                        {props.deHinderVoorHetWegverkeerCategorie && <b>{props.deHinderVoorHetWegverkeerCategorie}</b>}
                    </div>
                </div>
                <div className="mt15">
                    <b>{translate('inspectionLabel.environment')}</b>
                </div>
                <div className="row">
                    {' '}
                    <div className="col-md-4">
                        <img width="50px" src={String(milieuIconImage)} />
                    </div>
                    <div className="col-md-8">
                        {getSubScoreImage(props.milieuLabelScore)}
                        <br />
                        {translate('inspectionLabel.cO2emissions')}
                    </div>
                </div>
                {(props.inspectionType === 'rov' || props.inspectionType === 'scuba') && (
                    <>
                        <div className="mt15">
                            <b>{translate('inspectionLabel.efficiency')}</b>
                        </div>
                        <div className="row">
                            {' '}
                            <div className="col-md-4">
                                <img width="50px" src={String(rendementIconImage)} />
                            </div>
                            <div className="col-md-8">
                                {getSubScoreImage(props.rendementLabelScore)}
                                <br />
                                {translate('inspectionLabel.detectionEfficiency')}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
